// extracted by mini-css-extract-plugin
export default {"closeButton":"CloseButton_closeButton__8GGeH","closeButtonFloated":"CloseButton_closeButtonFloated__TeVnC","closeIcon":"CloseButton_closeIcon__XaTDt"};